import
{
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import { Wallet } from '@services/wallets/wallet.service';
import { FeeType } from '@shared/transaction-fee/transaction-fee.component';
import { fromEvent, merge, ReplaySubject } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';
import { parseToFirstNonZero } from 'src/app/services/utils';
import { IOracleFee } from 'src/app/services/wallets/utils.service';

@Component({
    selector: 'app-custom-gas-price',
    templateUrl: './custom-gas-price.component.html',
    styleUrls: [ './custom-gas-price.component.scss' ],
})
export class CustomGasPrice implements AfterViewInit, OnInit
{

    @Output() onChange: EventEmitter<any> = new EventEmitter();
    @Output() onClose: EventEmitter<any> = new EventEmitter();

    @Input('default-fee') defaultFee: FeeType = 'propose';
    @Input() default: string = '1';
    @Input('symbol') feeUnit: string;
    @Input('fee-oracle') feeOracle: IOracleFee;
    @Input() baseBalance: string;
    @Input() fiatBalance: string;
    @Input() baseUnit: string;
    @Input() fiatCustomFee: string;
    @Input() fiatCurrency: string;
    @Input() fiatPrice: string;
    @Input('fee-limit') feeLimit;
    @Input('wallet') wallet: Wallet;

    @ViewChild('inputEl') inputEl: ElementRef;

    public isProcessing: ReplaySubject<boolean> = new ReplaySubject(1);
    public customGasPrise: string;
    public oneShift: boolean = false;

    constructor(
        private cdr: ChangeDetectorRef,
    ) { }

    ngOnInit(): void
    {
        this.isProcessing.next(true);
    }

    ngAfterViewInit(): void
    {
        this.changeGas();
    }

    public changeGas()
    {
        merge(
            fromEvent(this.inputEl.nativeElement, 'keyup'),
            fromEvent(this.inputEl.nativeElement, 'input')
        )
            .pipe(
                tap(() =>
                {
                    this.isProcessing.next(true);
                    this.cdr.detectChanges();
                }),
                debounceTime(500))
            .subscribe(async (event_: any) =>
            {
                this.customGasPrise = await this.wallet.convertFeeGwei(event_.target.value, this.feeLimit, this.fiatPrice, true);
                this.fiatCustomFee = parseToFirstNonZero(Number(this.fiatPrice) * Number(this.customGasPrise));
                this.isProcessing.next(false);
                this.cdr.detectChanges();
            });

    }

    public onFeeChange(_fee)
    {
        if (!this.oneShift)
        {
            this.oneShift = !this.oneShift;
            return;
        }
        this.default = this.feeOracle[ _fee.type ].amount;
        this.inputEl.nativeElement.dispatchEvent(new Event('input'));
        this.cdr.detectChanges();
    }

    public onBack()
    {
        this.onClose.emit();
    }

    public submit()
    {
        this.onChange.emit(this.customGasPrise);
    }

    public getCoinPrice()
    {
        return Number(this.fiatCustomFee) / Number(this.fiatPrice);
    }
}
